import React, { createContext, useContext, useState, useCallback } from 'react';

const OrderDetailContext = createContext(null);

export const OrderDetailProvider = ({ children }) => {
  const [orderDetailData, setOrderDetailData] = useState({
    channelOrderId: '',
    orderStatus: '',
    order_cancel_sync_enable: false,
  });

  const updateOrderDetailData = useCallback(data => {
    setOrderDetailData({
      channelOrderId: data?.channel_order_id,
      orderStatus: data?.order_status,
      order_cancel_sync_enable: data?.order_cancel_sync_enable,
    });
  }, []);

  return (
    <OrderDetailContext.Provider
      value={{
        orderDetailData,
        updateOrderDetailData,
      }}
    >
      {children}
    </OrderDetailContext.Provider>
  );
};

export const useOrderDetailContext = () => useContext(OrderDetailContext);

export default OrderDetailProvider;
